import { useEffect, useMemo, useState } from 'react';
import { fetchAllBusinessesForAnalytics } from '../services/firestore';

function weekKey(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(d.setDate(diff));
  return monday.toISOString().slice(0, 10);
}

export default function Analytics() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      setRows(await fetchAllBusinessesForAnalytics());
    })();
  }, []);

  const metrics = useMemo(() => {
    const now = Date.now();
    const thirtyDaysAgo = now - (30 * 24 * 60 * 60 * 1000);

    const weekly = {};
    const lang = {};
    let active = 0;
    let trial = 0;
    let expired = 0;
    let cancelledRecent = 0;
    let convertedDays = [];

    for (const b of rows) {
      const created = b.createdAt?.toDate ? b.createdAt.toDate() : null;
      if (created) {
        const key = weekKey(created);
        weekly[key] = (weekly[key] || 0) + 1;
      }

      const language = b.language || 'en';
      lang[language] = (lang[language] || 0) + 1;

      if (b.planStatus === 'active') active += 1;
      if (b.planStatus === 'trial') trial += 1;
      if (b.planStatus === 'expired') expired += 1;

      const updated = b.updatedAt?.toDate ? b.updatedAt.toDate().getTime() : 0;
      if (b.planStatus === 'cancelled' && updated >= thirtyDaysAgo) cancelledRecent += 1;

      if (b.subscriptionStartDate?.toDate && b.trialStartDate?.toDate) {
        const days = Math.round((b.subscriptionStartDate.toDate() - b.trialStartDate.toDate()) / (24 * 60 * 60 * 1000));
        if (days >= 0) convertedDays.push(days);
      }
    }

    const conversion = active / Math.max(1, active + trial + expired) * 100;
    const churn30 = cancelledRecent / Math.max(1, rows.length) * 100;
    const avgUpgradeDays = convertedDays.length ? convertedDays.reduce((a, b) => a + b, 0) / convertedDays.length : 0;

    return { weekly, lang, conversion, churn30, avgUpgradeDays };
  }, [rows]);

  return (
    <>
      <div className="wb-grid" style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
        <div className="wb-card"><strong>{metrics.conversion.toFixed(1)}%</strong><div className="wb-muted">Trial to paid conversion</div></div>
        <div className="wb-card"><strong>{metrics.churn30.toFixed(1)}%</strong><div className="wb-muted">30-day churn</div></div>
        <div className="wb-card"><strong>{metrics.avgUpgradeDays.toFixed(1)}</strong><div className="wb-muted">Avg days to upgrade</div></div>
      </div>

      <div className="wb-card">
        <h3 className="wb-section-title">Weekly signups</h3>
        {Object.entries(metrics.weekly).sort(([a], [b]) => a < b ? 1 : -1).slice(0, 12).map(([k, v]) => (
          <div key={k} className="wb-row" style={{ justifyContent: 'space-between' }}><span>{k}</span><strong>{v}</strong></div>
        ))}
      </div>

      <div className="wb-card">
        <h3 className="wb-section-title">Language distribution</h3>
        {Object.entries(metrics.lang).map(([k, v]) => (
          <div key={k} className="wb-row" style={{ justifyContent: 'space-between' }}><span>{k}</span><strong>{v}</strong></div>
        ))}
      </div>
    </>
  );
}
